module.exports = __webpack_public_path__ + "static/media/signature-icon.763da2d5.svg";